"use client";

import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils/cn';

const labelVariants = cva('text-sm font-medium leading-none text-zen-text peer-disabled:cursor-not-allowed peer-disabled:opacity-70');

type LabelProps = Omit<React.ComponentPropsWithoutRef<'label'>, 'color'> & VariantProps<typeof labelVariants>;

const Label = React.forwardRef<
  HTMLLabelElement,
  LabelProps
>(({ className, ...props }, ref) => (
  <label ref={ref} className={cn(labelVariants(), className)} {...props} />
));
Label.displayName = 'Label';

export { Label };
